
import { Component, Mixins } from 'vue-property-decorator';
import { iSort, iVirtualKeyBoardQuery, iVirtualKeyBoard, eAuditState, eSortField, eUpdateState, eUpdateType } from '@/interface/virtual-keyboard';
import { toast } from '@/utils/common';
import { PageQuery } from '@/mixins/page_query';
import {
  getVirtualKeyboardList,
  delVirtualKeyboard,
  moveVirtualKeyboard,
  updateVirtualKeyboard,
  sortByKey,
  releaseVirtualKeyboard,
  auditVirtualKeyboard,
} from '@/api/virtual-keyboard';
import ShowPreview from '@/views/marketing/virtual-keyboard/components/preview.vue';
import Detial from '@/views/marketing/virtual-keyboard/components/detail.vue';
import { eSortType } from '@/interface/eCommand';
@Component({ components: { Detial, ShowPreview } })
export default class VirtuaKeyBoard extends Mixins(PageQuery) {
  detailsTable: any = []; //列表详情
  showTitle: string = '';
  loading: boolean = false;
  dialogVisible: boolean = false; //详情
  dialogPreviewVisible: boolean = false; //预览
  selectTypeIndex: number = 0; //选中类型 ，0官方 1网友上传 2待审核
  pendingReview = eUpdateType.PENDINGREVIEW; //待审核
  offical = eUpdateType.OFFICIAL; //官方推荐
  netFried = eUpdateType.NETFRIEND; //网页上传
  auditPass = eAuditState.PASS;
  auditReject = eAuditState.REJECT;
  preview: object = {
    keyboard_setting_infos: [
      {
        x_posi: 38,
        y_posi: 147,
        showX: 0,
        showY: 0,
        width: 44,
        height: 44,
        text: 'Esc',
        type: 0,
        type_press: 0,
        command_arr: ['Esc'],
        code_arr: [41],
        direction: 1,
        keyboard_type: 0,
      },
      {
        x_posi: 378,
        y_posi: 208,
        showX: 0,
        showY: 0,
        width: 44,
        height: 44,
        text: 'Enter',
        type: 0,
        type_press: 0,
        command_arr: ['Enter'],
        code_arr: [40],
        direction: 1,
        keyboard_type: 0,
      },
    ],
    mouse_setting_infos: [
      {
        x_posi: 435,
        y_posi: 190,
        showX: 0,
        showY: 0,
        width: 58,
        height: 58,
        type_press: 0,
        command: 'left',
        code: 10000,
        type: 0,
        text: '',
        direction: 1,
        keyboard_type: 0,
        command_arr: null,
      },
      {
        x_posi: 504,
        y_posi: 175,
        showX: 0,
        showY: 0,
        width: 58,
        height: 58,
        type_press: 0,
        command: 'right',
        code: 10001,
        type: 0,
        text: '',
        direction: 1,
        keyboard_type: 0,
        command_arr: null,
      },
    ],
    handle_setting_infos: [],
  };
  pass: eUpdateState = eUpdateState.PASS;
  reject: eUpdateState = eUpdateState.REJECT;
  typeList: object[] = [
    { id: eUpdateType.OFFICIAL, name: '官方推荐' },
    { id: eUpdateType.NETFRIEND, name: '网友上传' },
    { id: eUpdateType.PENDINGREVIEW, name: '待审核' },
  ];
  keyBoardTyleList: object[] = [
    { id: -1, name: '请选择类型' },
    { id: 0, name: '键盘' },
    { id: 1, name: '手柄' },
  ];
  updateTypeList: object[] = [
    { id: -1, name: '请选择有无更新' },
    { id: 2, name: '有更新' },
    { id: 1, name: '无更新' },
  ];
  auditTypeList: object[] = [
    { id: -1, name: '请选择状态' },
    { id: 0, name: '待审核' },
    { id: 2, name: '不通过' },
  ];
  model: iVirtualKeyBoard = {
    sort: 0,
    file_id: 0,
    name: '',
    file_type_name: '',
    preview: {},
    update_preview: {},
    like_num: 0,
    used_num: 0,
    status: 0,
    uname: '',
    uid: 0,
    has_update: -1,
    approval_time: '',
    upload_time: '',
    update_time: '',
    agree_update_time: '',
    update_preview_name: '',
  };
  ids: string = '';
  auditID: string = ''; //需要审核ID
  isBatchAudit: boolean = false; //是否批量审核
  exitTitle: string = '配置详情';
  searchInfo: iVirtualKeyBoardQuery = {
    name: '',
    file_id: '',
    uname_id: '',
    file_type: -1,
    has_update: -1,
    order_by: 0,
    order_rule: 0,
    page_type: this.selectTypeIndex,
    audit_status: -1,
  };
  public page_query = {
    page: 1,
    page_size: 30,
  };

  /* 查询 */
  searchList() {
    this.page_query.page = 1;
    this.getList();
  }
  //行审核
  auditRow(row: iVirtualKeyBoard) {
    this.clear();
    this.dialogVisible = true;
    this.auditID = row.file_id.toString();
    this.model = row;
  }
  //批量审核
  batchAudit() {
    if (this.ids.trim() == '') {
      toast('请选择审核的虚拟键盘', 'error');
      return;
    }
    this.dialogVisible = true;
    this.isBatchAudit = true;
    this.auditID = this.ids;
  }
  /* 编辑 */
  detailRow(row: any) {
    this.clear();
    this.dialogVisible = true;
    this.model = row;
  }
  /* 预览 */
  showPreview(row: iVirtualKeyBoard, type: number) {
    let str: any;
    if (type == 1) {
      str = row.preview;
    } else {
      str = row.update_preview;
    }
    // console.log(str, 'str');

    this.preview = str ? JSON.parse(str) : {};
    // console.log(this.preview);
    this.showTitle = row.name + '(' + row.update_preview_name + ')';
    this.dialogPreviewVisible = !this.dialogPreviewVisible;
  }
  handleSizeChange(size: number) {
    this.page_query.page = 1;
    this.page_query.page_size = size;
    this.getList();
  }
  handleCurrentChange(page: number) {
    this.page_query.page = page;
    this.getList();
  }

  delVirtualKeyboard() {
    if (this.ids.trim() == '') {
      toast('请选择删除的虚拟键盘', 'error');
      return;
    }
    this.removeRow();
  }
  //查询列表
  async getList() {
    this.loading = true;
    try {
      this.searchInfo.page_type = this.selectTypeIndex;
      const res = await getVirtualKeyboardList({ ...this.searchInfo, ...this.page_query });
      this.detailsTable = [];
      if (res && res.code == 0) {
        this.detailsTable = res.data.rows;
        this.total = res.data.count;
      }
    } catch (err) {
      console.log(err);
    } finally {
      this.loading = false;
    }
  }
  handleSelectionChange(val: any) {
    this.ids = val
      .map((item: any) => {
        return item.file_id;
      })
      .join(',');
  }
  /* 排序 */
  async upSort(row: any, sort: string) {
    let sortItem = {
      id: row.file_id || -1,
      sort: sort,
    };
    try {
      this.loading = true;
      const res = await sortByKey(sortItem);
      if (res && res.code == 0) {
        toast('操作成功');
        this.getList();
      }
    } catch (err) {
      console.log(err);
    } finally {
      this.loading = false;
    }
  }

  /* 移动 */
  async moveVirtualKeyboard(page_type: eUpdateType) {
    if (this.ids == '') {
      toast('请选择要移动的虚拟键盘', 'error');
      return;
    }
    this.$msgbox({
      title: '提示',
      message: '是否确认移动？',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      beforeClose: async (action, instance, done) => {
        if (action === 'confirm') {
          instance.confirmButtonLoading = true;
          instance.confirmButtonText = '执行中...';
          this.loading = true;
          let moveItem = {
            id: this.ids,
            page_type: page_type,
          };
          const res = await moveVirtualKeyboard(moveItem);
          if (res && res.code == 0) {
            toast('操作成功');
            this.searchList();
          }
          done();
          instance.confirmButtonLoading = false;
        } else if (action === 'cancel') {
          done();
          instance.confirmButtonLoading = false;
        }
      },
    })
      .then(() => {})
      .catch((err: any) => {
        console.log(err);
      })
      .finally(() => {
        this.loading = false;
      });
  }
  /* 删除 */
  async removeRow(row?: any) {
    if (row) {
      this.ids = row.file_id;
    }
    if (this.ids == '') {
      toast('请选择要删除的虚拟键盘', 'error');
      return;
    }

    this.$msgbox({
      title: '提示',
      message: '是否确认删除，删除后将不提供给用户使用!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      beforeClose: async (action, instance, done) => {
        if (action === 'confirm') {
          instance.confirmButtonLoading = true;
          instance.confirmButtonText = '执行中...';
          this.loading = true;
          const obj = { id: this.ids, page_type: this.selectTypeIndex };
          const res: any = await delVirtualKeyboard(obj);
          done();
          if (res && res.code == 0) {
            toast('操作成功');
            this.searchList();
          }
          instance.confirmButtonLoading = false;
        } else if (action === 'cancel') {
          done();
          instance.confirmButtonLoading = false;
        }
      },
    })
      .then(() => {})
      .catch((err: any) => {
        console.log(err);
      })
      .finally(() => {
        this.loading = false;
      });
  }
  /* 虚拟键盘更新通过/拒绝 */
  async updateVirtualKeyboard(state: eUpdateState) {
    if (this.ids == '') {
      toast('请选择通过的虚拟键盘', 'error');
      return;
    }
    const title = state == eUpdateState.PASS ? '确认更新通过吗？确认后，将覆盖原有配置内容!' : '确认更新拒绝吗？拒绝后，该配置将不会更新!';
    this.$msgbox({
      title: '提示',
      message: title,
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      beforeClose: async (action, instance, done) => {
        if (action === 'confirm') {
          instance.confirmButtonLoading = true;
          instance.confirmButtonText = '执行中...';
          this.loading = true;
          const obj = { id: this.ids, choice_update: state };
          const res: any = await updateVirtualKeyboard(obj);
          done();
          if (res && res.code == 0) {
            toast('操作成功');
            this.dialogVisible = false;
            this.searchList();
          }
          instance.confirmButtonLoading = false;
        } else if (action === 'cancel') {
          done();
          instance.confirmButtonLoading = false;
        }
      },
    })
      .then(() => {})
      .catch((err: any) => {
        console.log(err);
      })
      .finally(() => {
        this.loading = false;
      });
  }
  /* 发布 */
  releaseVirtualKeyboard() {
    this.$msgbox({
      title: '提示',
      message: '请仔细预览，确认信息无误后，发布是否确认发布？',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      beforeClose: async (action, instance, done) => {
        if (action === 'confirm') {
          instance.confirmButtonLoading = true;
          instance.confirmButtonText = '执行中...';
          this.loading = true;
          const res: any = await releaseVirtualKeyboard(1); //终端类型 1安卓端 2web端
          done();
          if (res.code == 0) {
            toast('发布成功');
          } else {
            toast(res.msg, 'error');
          }
          instance.confirmButtonLoading = false;
        } else if (action === 'cancel') {
          done();
          instance.confirmButtonLoading = false;
        }
      },
    })
      .then(() => {})
      .catch((err: any) => {
        console.log(err);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  /* 虚拟键盘审核 */
  auditVirtualKeyboard(id: string, move_to: number, is_approved: any) {
    const title = is_approved == this.auditPass ? '确定要审核通过？' : '确定要拒绝审核？';
    const newId = this.isBatchAudit ? this.ids : id;
    this.$msgbox({
      title: '提示',
      message: title,
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      beforeClose: async (action, instance, done) => {
        if (action === 'confirm') {
          instance.confirmButtonLoading = true;
          instance.confirmButtonText = '执行中...';
          this.loading = true;
          const obj = { id: newId, is_approved, move_to };
          const res: any = await auditVirtualKeyboard(obj);
          done();
          if (res.code == 0) {
            toast('操作成功');
            this.getList();
            this.clearAudit();
          } else {
            toast(res.msg, 'error');
          }
          instance.confirmButtonLoading = false;
        } else if (action === 'cancel') {
          done();
          instance.confirmButtonLoading = false;
        }
      },
    })
      .then(() => {})
      .catch((err: any) => {
        console.log(err);
      })
      .finally(() => {
        this.loading = false;
      });
  }
  closeDetail() {
    this.clear();
    this.clearAudit(); //清理审核中需要的状态
  }
  // 清理审核中需要的状态
  clearAudit() {
    this.isBatchAudit = false;
    this.auditID = '';
    this.dialogVisible = false;
  }
  clear() {
    this.model = {
      sort: 0,
      file_id: 0,
      name: '',
      file_type_name: '',
      preview: {},
      update_preview: {},
      like_num: 0,
      used_num: 0,
      status: 0,
      uname: '',
      uid: 0,
      has_update: -1,
      approval_time: '',
      upload_time: '',
      update_time: '',
      agree_update_time: '',
      update_preview_name: '',
    };
  }
  editOk() {
    this.clear();
    this.getList();
    this.dialogVisible = false;
  }
  /* 行选择*/
  toggleSelection(rows: any, column: any) {
    try {
      if (column.label != '操作') {
        (this.$refs['selectTableDate'] as any).toggleRowSelection(rows);
      }
    } catch {
      // console.log('111');
    }
  }
  /* 排序 */
  sortChange(val: any) {
    const { prop, order } = val;
    if (prop && order) {
      this.searchInfo.order_by = Number(eSortField[prop.toUpperCase()]);
      this.searchInfo.order_rule = Number(eSortType[order.substring(0, 3).toUpperCase()]);
      this.searchList();
    }
  }
  mounted() {
    this.pageFn = this.getList;
    this.getList();
  }
}
